module.exports = __webpack_public_path__ + "img/image-thumb-5.f1769469.jpg";